import { createBrowserRouter } from 'react-router-dom';
import paths from './paths';
import App from '../App';
import Dashboard from '../pages/dashboard/Dashboard.page';
import ProtectedRoutes from './ProtectedRoutes.component';

const router = createBrowserRouter([
  {
    path: paths.ROOT,
    element: <App />,
  },
  {
    element: <ProtectedRoutes />,
    children: [
      {
        path: paths.DASHBOARD,
        element: <Dashboard />,
      },
    ],
  },
]);
export default router;
